import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import * as pages from '@/components/pages'

Vue.use(Router)

const _authGuard = (to, from, next) => {
  if (!store.state.userObject) {
    next('/start')
    return
  }
  next()
}

export default new Router({
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash }
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'BootstrapPage',
      component: pages.BootstrapPage
    },
    {
      path: '/start',
      name: 'StartPage',
      component: pages.StartPage
    },
    {
      path: '/intro',
      name: 'IntroPage',
      component: pages.IntroPage
    },
    {
      path: '/home',
      name: 'HomePage',
      component: pages.HomePage,
      beforeEnter: _authGuard
    },
    {
      path: '/register',
      name: 'RegisterPage',
      component: pages.RegisterPage
    },
    {
      path: '/assessment/:childId/:age',
      name: 'AssessmentPage',
      component: pages.AssessmentPage,
      beforeEnter: _authGuard
    },
    {
      path: '/assessment/:childId/:age/result/:result',
      name: 'AssessmentResultPage',
      component: pages.AssessmentResultPage,
      beforeEnter: _authGuard
    },
    {
      path: '/assessment/:childId/:age/review',
      name: 'AssessmentReviewPage',
      component: pages.AssessmentReviewPage,
      beforeEnter: _authGuard
    },
    {
      path: '/settings',
      name: 'SettingsPage',
      component: pages.SettingsPage,
      beforeEnter: _authGuard
    },
    {
      path: '/aboutus',
      name: 'AboutUsPage',
      component: pages.AboutUsPage
    },
    {
      path: '/privacy',
      name: 'PrivacyPage',
      component: pages.PrivacyPage
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js